module.exports = __webpack_public_path__ + "static/media/redux.f75f706a.svg";